export default {
  themes: {
    default: {
      light: {
        colors: {

          customBtnBgColor: '#adadad',

          customNavColor: '#64748B',
          customContainerBorder: '#d6d6d6',
          customContainerBg: '#ffffff',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#fff',
          primary: '#009fb7',
          secondary: '#6a6a6f',
          accent: '#e1a402',
          error: '#ef476f',
          info: '#febf08',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#e9edef',
          customDrawerBg: '#e9edef',
          tableBorderLinesColor: '#6a6a6f',
          customInputBorderColor: '#6a6a6f',
          customStepLogSelect: '#f0eff4'
        }
      },
      dark: {
        colors: {

          customBtnBgColor: '#6a6a6f',
          customNavColor: '#FFFFFF',

          searchandpermBg: '#1C1C1C',
          customContainerBorder: '#6a6a6f',
          customContainerBg: '#101114',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#009fb7',
          secondary: '#6a6a6f',
          accent: '#ffd867',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#23272e',
          customDrawerBg: '#1B1C1C',
          tableBorderLinesColor: '#6a6a6f',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      }

    },
    dark: {
      colors: {

        customBtnBgColor: '#6a6a6f',
        customNavColor: '#FFFFFF',

        searchandpermBg: '#1C1C1C',
        customContainerBorder: '#6a6a6f',
        customContainerBg: '#101114',

        activeStatus: '#51A570',
        activeStatusBg: '#0D331C',
        activeStatusBorder: '#51A570',

        deactiveStatus: '#F05555',
        deactiveStatusBg: '#3D1212',
        deactiveStatusBorder: '#F05555',

        textbase: '#ecefef',
        surface: '#101114',
        primary: '#009fb7',
        secondary: '#6a6a6f',
        accent: '#ffd867',
        error: '#FF5252',
        info: '#2196F3',
        success: '#05c075',
        warning: '#febf08',
        timeline: '#505050',
        timelineBg: '#0f0f0f',
        customBg: '#23272e',
        customDrawerBg: '#1B1C1C',
        tableBorderLinesColor: '#6a6a6f',
        customInputBorderColor: '#6a6a6f',
        customStepLogSelect: '#2a2b2a'
      }
    },
    light: {
      colors: {

        customBtnBgColor: '#adadad',

        customNavColor: '#64748B',
        customContainerBorder: '#d6d6d6',
        customContainerBg: '#ffffff',

        activeStatus: '#22C55E',
        activeStatusBg: '#c9ffde',
        activeStatusBorder: '#22C55E',

        deactiveStatus: '#DC2626',
        deactiveStatusBg: '#fac3c3',
        deactiveStatusBorder: '#EF4444',

        textbase: '#1f1f1f',
        surface: '#f0eff4',
        primary: '#009fb7',
        secondary: '#6a6a6f',
        accent: '#febf08',
        error: '#ef476f',
        info: '#2196F3',
        success: '#05c075',
        warning: '#fecf65',
        timeline: '#cbcbcb',
        timelineBg: '#ffffff',
        customBg: '#e9edef',
        customDrawerBg: '#e9edef',
        tableBorderLinesColor: '#6a6a6f',
        customInputBorderColor: '#858585',
        customStepLogSelect: '#f0eff4'
      }
    },
    goldenrod: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#c78b19',
          secondary: '#3a3f55',
          accent: '#897255',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#1a262f',
          customDrawerBg: '#1B1C1C',
          tableBorderLinesColor: '#3a3f55',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },

      // light theme colors
      light: {
        colors: {

          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#af7608',
          secondary: '#393337',
          accent: '#897255',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#f1f5fa',
          customDrawerBg: '#f1f5fa',
          tableBorderLinesColor: '#595959',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    magenta: {
      dark: {
        colors: {

          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#A3006A',
          secondary: '#7e556d',
          accent: '#4D7298',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#14000E',
          customDrawerBg: '#1B1C1C',
          tableBorderLinesColor: '#a39ba8',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },

      // light theme colors
      light: {
        colors: {

          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#672A4E',
          secondary: '#505050',
          accent: '#5EDDFD',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#FFD6F3',
          customDrawerBg: '#FFEBF9',
          tableBorderLinesColor: '#f492ff',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    violet: {
      dark: {
        colors: {

          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#A356F0',
          secondary: '#585265',
          accent: '#fec85a',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#271F30',
          customDrawerBg: '#1B1C1C',
          tableBorderLinesColor: '#594771',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },

      // light theme colors
      light: {
        colors: {

          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#7A14E1',
          secondary: '#343434',
          accent: '#af7608',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#af7608',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#e7d9e7',
          customDrawerBg: '#d8cedf',
          tableBorderLinesColor: '#656565',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    mint: {
      dark: {
        colors: {

          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#7E9933',
          secondary: '#345995',
          accent: '#CBEAA6',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#2a2d25',
          customDrawerBg: '#1B1C1C',
          tableBorderLinesColor: '#345995',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },

      // light theme colors
      light: {
        colors: {

          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#7E9933',
          secondary: '#345995',
          accent: '#03440C',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#fbfeee',
          customDrawerBg: '#CBEAA6',
          tableBorderLinesColor: '#345995',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      }
    },
    blue: {
      dark: {
        colors: {

          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#227fea',
          secondary: '#505050',
          accent: '#ffd867',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#012d42',
          customDrawerBg: '#0a0a0d',
          tableBorderLinesColor: '#518cc6',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#ebebfe'
        }
      },

      // light theme colors
      light: {
        colors: {

          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#0065cd',
          secondary: '#000',
          accent: '#febf08',
          error: '#ef476f',
          info: '#0065cd',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#bfecf2',
          customDrawerBg: '#e9edef',
          tableBorderLinesColor: '#606060',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    coral: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#F08E6B',
          secondary: '#8B7B77',
          accent: '#4ECDC4',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#2A1F1D',
          customDrawerBg: '#1B1918',
          tableBorderLinesColor: '#A08070',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },
      light: {
        colors: {
          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#E07850',
          secondary: '#5D4E4A',
          accent: '#2A9D8F',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#FFF5F2',
          customDrawerBg: '#FFEEE8',
          tableBorderLinesColor: '#8B7355',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    slate: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#64748B',
          secondary: '#94A3B8',
          accent: '#FBBF24',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#1E293B',
          customDrawerBg: '#0F172A',
          tableBorderLinesColor: '#475569',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },
      light: {
        colors: {
          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#475569',
          secondary: '#334155',
          accent: '#F59E0B',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#F1F5F9',
          customDrawerBg: '#E2E8F0',
          tableBorderLinesColor: '#64748B',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    emerald: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#3DAA7A',
          secondary: '#8B9AAF',
          accent: '#E8C090',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#1A2A22',
          customDrawerBg: '#152118',
          tableBorderLinesColor: '#3DAA7A',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },
      light: {
        colors: {
          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#2D8A5F',
          secondary: '#4A5568',
          accent: '#D4A574',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#F0F9F4',
          customDrawerBg: '#E5F5EC',
          tableBorderLinesColor: '#2D8A5F',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    indigo: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#6366F1',
          secondary: '#818CF8',
          accent: '#F9A8D4',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#1E1B4B',
          customDrawerBg: '#15123A',
          tableBorderLinesColor: '#6366F1',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },
      light: {
        colors: {
          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#4F46E5',
          secondary: '#3730A3',
          accent: '#F472B6',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#EEF2FF',
          customDrawerBg: '#E0E7FF',
          tableBorderLinesColor: '#4F46E5',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    crimson: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#E05555',
          secondary: '#8A8A8A',
          accent: '#4ECDC4',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#2D1A1A',
          customDrawerBg: '#1F1515',
          tableBorderLinesColor: '#E05555',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },
      light: {
        colors: {
          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#C23B3B',
          secondary: '#4A4A4A',
          accent: '#2E8B8B',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#FFF5F5',
          customDrawerBg: '#FFECEC',
          tableBorderLinesColor: '#C23B3B',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    rose: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#EC4899',
          secondary: '#9CA3AF',
          accent: '#34D399',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#2D1F26',
          customDrawerBg: '#231A1E',
          tableBorderLinesColor: '#EC4899',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },
      light: {
        colors: {
          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#BE185D',
          secondary: '#6B7280',
          accent: '#059669',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#FFF1F5',
          customDrawerBg: '#FCE7F0',
          tableBorderLinesColor: '#BE185D',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    orange: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#F97316',
          secondary: '#A1A1AA',
          accent: '#38BDF8',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#2A1D14',
          customDrawerBg: '#1F1710',
          tableBorderLinesColor: '#F97316',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },
      light: {
        colors: {
          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#EA580C',
          secondary: '#52525B',
          accent: '#0284C7',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#FFF7ED',
          customDrawerBg: '#FFEDD5',
          tableBorderLinesColor: '#EA580C',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    },
    amber: {
      dark: {
        colors: {
          customContainerBg: '#101114',
          customContainerBorder: '#6a6a6f',
          customNavColor: '#FFFFFF',

          activeStatus: '#51A570',
          activeStatusBg: '#0D331C',
          activeStatusBorder: '#51A570',

          deactiveStatus: '#F05555',
          deactiveStatusBg: '#3D1212',
          deactiveStatusBorder: '#F05555',

          textbase: '#ecefef',
          surface: '#101114',
          primary: '#F59E0B',
          secondary: '#A8A29E',
          accent: '#8B5CF6',
          error: '#FF5252',
          info: '#2196F3',
          success: '#05c075',
          warning: '#febf08',
          timeline: '#505050',
          timelineBg: '#0f0f0f',
          customBg: '#292115',
          customDrawerBg: '#1F1A10',
          tableBorderLinesColor: '#F59E0B',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#2a2b2a'
        }
      },
      light: {
        colors: {
          customContainerBg: '#ffffff',
          customContainerBorder: '#d6d6d6',
          customNavColor: '#64748B',

          activeStatus: '#22C55E',
          activeStatusBg: '#c9ffde',
          activeStatusBorder: '#22C55E',

          deactiveStatus: '#DC2626',
          deactiveStatusBg: '#fac3c3',
          deactiveStatusBorder: '#EF4444',

          textbase: '#1f1f1f',
          surface: '#f0eff4',
          primary: '#D97706',
          secondary: '#57534E',
          accent: '#7C3AED',
          error: '#ef476f',
          info: '#2196F3',
          success: '#05c075',
          warning: '#fecf65',
          timeline: '#cbcbcb',
          timelineBg: '#ffffff',
          customBg: '#FFFBEB',
          customDrawerBg: '#FEF3C7',
          tableBorderLinesColor: '#D97706',
          customInputBorderColor: '#858585',
          customStepLogSelect: '#f0eff4'
        }
      }
    }
  }
}
